import React, { useRef }  from 'react'
import ReactHlsPlayer from 'react-hls-player'

const CustomVideoPlayer = ({ numPlaces, src, horses, racePlayed }) => {
  const playerRef = useRef()

  React.useEffect(() => {
    function fireOnVideoStart() {
      racePlayed()
    }
    playerRef.current.addEventListener('play', fireOnVideoStart);
  }, []);

  return <div>
    <ReactHlsPlayer
      playerRef={playerRef}
      crossOrigin="anonymous"
      src={src}
      autoPlay={false}
      controls={true}
      width="100%"
      height="auto"
    />
    <style jsx>{`
      .silk-bar {
        min-height: 100px;
        opacity: 0;
        margin: 0 auto;
      }
      .fade-in {
        opacity: 1;
        transition: opacity 2s linear;
      }
      .fade-out {
        opacity: 0;
        transition: opacity 2s linear;
      }
      @keyframes fadeIn {
        0% {opacity:0;}
        100% {opacity:1;}
      }
    `}</style>
  </div>
}

export default CustomVideoPlayer


